import { ApolloProvider } from '@apollo/client';
import { ActiveLanguageProvider, client, SupportedLocalesCode } from '@carlito/api';
import { BookitoProvider } from '@carlito/bookito-client';
import i18n from '@carlito/react-intl';
import React from 'react';

const BookitoWidgetProvider: React.FC<{ language?: SupportedLocalesCode; hotelId?: string }> = (
  props
) => {
  return (
    <ApolloProvider client={client}>
      <ActiveLanguageProvider
        hotelId={props.hotelId}
        browserLocale={props.language ?? (i18n.language as SupportedLocalesCode)}
      >
        <BookitoProvider>{props.children}</BookitoProvider>
      </ActiveLanguageProvider>
    </ApolloProvider>
  );
};

export default BookitoWidgetProvider;
